import { Reducer } from 'redux';
import type { LegacyAction } from '~/types/actions.types';
import ErrorConstants from './constants';
import UnhandledErrorRecord from './data/UnhandledErrorRecord';

function getInitialState() {
  return new UnhandledErrorRecord();
}

const defaultState = getInitialState();

const reducer: Reducer<UnhandledErrorRecord, LegacyAction> = (state = defaultState, action) => {
  switch (action.type) {
    case ErrorConstants.ERROR:
      return state.merge({
        error: action.error,
        view: action.view,
        persistant: action.persistant,
      });

    case ErrorConstants.CLEAR_ERROR:
      return getInitialState();

    case ErrorConstants.CLEAR_ERROR_FROM_VIEW: {
      if (state && state.persistant) {
        return state;
      }

      if (state && state.view && state.view === action.view) {
        return getInitialState();
      }
      return state;
    }

    default:
      return state;
  }
};

export default reducer;
